/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Promo_TagInputs */

const vi_shop_home_promo_tag = /** @type {(inputs: Shop_Home_Promo_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhãn nhỏ`)
};

/**

* @param {Shop_Home_Promo_TagInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_promo_tag = /** @type {((inputs?: Shop_Home_Promo_TagInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Promo_TagInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_promo_tag(inputs)
});